import './EventEndScreen.css';
import Footer from '../_Components/Footer';
import confetti_desktop from '../../assets/images/animations/confetti_desktop.json';
import confetti_mobile from '../../assets/images/animations/confetti_mobile.json';
import highFive from '../../assets/images/icons/high-five.svg';
import Lottie from 'lottie-react';
import { useState, useEffect } from 'react';
import { useFormUrl, useLiveUrl } from '../../context/SessionContext';
import { SoundWaveIcon, YouTubeIcon } from '../../components/Icons';

export default function EventEndScreen() {
  const [isMobile, setIsMobile] = useState(false);
  const formUrl = useFormUrl();
  const liveUrl = useLiveUrl();

  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkIfMobile();
    window.addEventListener('resize', checkIfMobile);

    return () => window.removeEventListener('resize', checkIfMobile);
  }, []);

  return (
    <div className='event-end-screen' style={{ minHeight: '100vh' }}>
      <div id='container'>
        <Lottie
          animationData={isMobile ? confetti_mobile : confetti_desktop}
          autoPlay={true}
          loop={true}
          className='confetti-animation'
          style={{
            zIndex: 999,
          }}
        />

        <div className='main-content flex justify-center items-center flex-column content-container'>
        <img src={highFive} alt='High five icon' className='high-five-icon' />
        <h1 className='mt-2 text-center'>Sessione completata!</h1>
        <h3 className='subtitle-text'>
          Continua a seguire la live per vedere le soluzioni degli esercizi
        </h3>

        <a href={liveUrl} target='_blank' rel='noopener noreferrer' className='mt-4 live-button'>
          <YouTubeIcon />
          Segui la correzione live{' '}
          <SoundWaveIcon />
        </a>

        <span className='mt-8 span-with-lines'>
          Hai dei dubbi sulle domande?
        </span>

        <a href={formUrl} target='_blank' rel='noopener noreferrer' className='button-ghost mt-4'>Scrivici i tuoi dubbi</a>
        <p>e noi risponderemo live - sarai anonimo</p>
        </div>

        <Footer />
      </div>
    </div>
  );
}
